import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import RoomTheme from "%/dynamic-components/render-engine/options/room-theme";
import ShowEventTitle from "%/dynamic-components/render-engine/options/show-event-title";
import ShowElapsedTimer from "%/dynamic-components/render-engine/options/show-elapsed-timer";
import ShowLiveBadge from "%/dynamic-components/render-engine/options/show-live-badge";
import ShowViewerCount from "%/dynamic-components/render-engine/options/show-viewer-count";
import ShowStatusChip from "%/dynamic-components/render-engine/options/show-status-chip";
import IntermissionImage from "%/dynamic-components/render-engine/options/intermission-image";
import IntermissionText from "%/dynamic-components/render-engine/options/intermission-text";

export default class EventRoomOptions extends BaseOptionsBundle {

  optionTitle = "Room";
  static optionClassName = "i-dynamic-event-room-bundle";

  constructor(values = {}) {
    super(values, [
      RoomTheme,
      ShowEventTitle,
      ShowElapsedTimer,
      ShowLiveBadge,
      ShowViewerCount,
      ShowStatusChip,
      IntermissionImage,
      IntermissionText,
    ]);
  }
}
